import script from "./ReportProblemPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportProblemPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ReportProblemPopup.vue?vue&type=style&index=0&id=2017e2a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2017e2a6"]])

export default __exports__